'use client';

import { useIsLoading, useIsLogined } from '@/contexts/LoginContext';
import { SeoTextBlock } from '.';
import { SeoStatistics } from '@/components/seo-statistics/SeoStatistics';
import type { SeoStatisticsBlockResponseDto } from '@gen/types/SeoStatisticsBlockResponseDto';

type Props = {
  header: string;
  seoText: string;
  initialIsLoggedIn: boolean;
  statisticsBlocks?: SeoStatisticsBlockResponseDto[];
  statisticsUpdatedAt?: string | null;
};

export function GuestSeoTextBlock({
  header,
  seoText,
  initialIsLoggedIn,
  statisticsBlocks,
  statisticsUpdatedAt,
}: Props) {
  const isLogined = useIsLogined();
  const isLoading = useIsLoading();
  const isLoggedIn = isLoading ? initialIsLoggedIn : isLogined;

  const hasStatistics = !!statisticsBlocks?.length;
  const hasText = !isLoggedIn && !!(header || (seoText?.trim() && seoText.trim() !== '<p></p>'));

  if (!hasText && !hasStatistics) return null;

  return (
    <div className='mt-8 space-y-4 md:mt-12 md:space-y-6'>
      <SeoStatistics blocks={statisticsBlocks} updatedAt={statisticsUpdatedAt} />
      {hasText && (
        <div className='rounded-2xl bg-light-green-bg p-5 md:p-8'>
          <SeoTextBlock header={header} seoText={seoText} embedded divider={false} />
        </div>
      )}
    </div>
  );
}
